/**
 * Constantes da aplicação
 * 
 * Este arquivo centraliza todas as informações importantes do negócio
 * para evitar duplicação de código e facilitar manutenção.
 * 
 * Se precisar mudar o endereço ou telefone, basta alterar aqui!
 */

export const BUSINESS_INFO = {
  // Informações de contato
  name: 'Eco Lavanderia Express',
  phone: '5531999901010',
  address: 'Av. Álvares Cabral, 894 - Lourdes, Belo Horizonte - MG, 30170-001',
  
  // Slogan e descrição
  tagline: 'Lavagem e secagem rápidas, com opção de serviço completo e/ou autoatendimento.',
  subTagline: 'Serviço completo para quem não tem tempo',
  
  // URLs úteis
  whatsappUrl: 'https://wa.me/5531999901010',
  googleMapsUrl: 'https://www.google.com/maps/place/Eco+Lavanderia+Express/@-19.9299202,-43.9484361,17z/data=!4m8!3m7!1s0xa6997c5493de75:0x92ff63572a8348a0!8m2!3d-19.9299325!4d-43.9454122!9m1!1b1!16s%2Fg%2F11x7n6tvg5?hl=pt-BR',
  instagramUrl: 'https://instagram.com/eco.lavanderiaexpress',
  
  // Horário de funcionamento
  workingHours: {
    weekdays: 'Segunda a sexta: 8:00 às 22:00',
    saturday: 'Sábado: 8:00 às 22:00',
    sunday: 'Domingo: 8:00 às 22:00',
    lastService: 'Último horário para iniciar lavagem: 21:30',
    note: 'Funcionamos todos os dias, inclusive feriados!'
  },
  
  // Pontos de referência
  landmarks: [
    'Próximo ao Minas Shopping',
    'Região de Lourdes',
    'Delivery na região disponível'
  ],
  
  // Serviços oferecidos
  services: {
    title: 'Nossos Serviços',
    subtitle: 'Você deixa a roupa, a gente cuida de tudo.',
    list: [
      {
        name: 'Autoatendimento',
        description: 'Use nossas máquinas modernas de forma rápida e prática',
        icon: 'self-service'
      },
      {
        name: 'Serviço Completo',
        description: 'Lavar, secar e dobrar - você deixa, a gente cuida de tudo',
        icon: 'full-service'
      },
      {
        name: 'Edredons e Cobertores',
        description: 'Peças grandes com cuidado especial e máquinas adequadas',
        icon: 'bedding'
      },
      {
        name: 'Roupas do Dia a Dia',
        description: 'Do casual ao social, tratamos suas roupas com carinho',
        icon: 'daily'
      }
    ]
  },
  
  // Preços
  pricing: {
    selfService: 'A partir de R$ 15,00 por máquina',
    fullService: 'Serviço completo sob consulta',
    note: 'Entre em contato para orçamento personalizado'
  },
  
  // Diferencial humano
  humanTouch: {
    title: 'Atendimento Humanizado',
    message: 'Atendimento feito com cuidado e atenção aos detalhes.',
    description: 'Não somos apenas máquinas! Nossa equipe está sempre presente para orientar, ajudar e garantir que suas roupas recebam o melhor tratamento.',
    owner: 'Aqui você encontra profissionais dedicados que entendem a importância de cada peça de roupa para você.'
  }
} as const;

/**
 * Configurações do Google Ads
 * 
 * ID de conversão usado para rastrear ações importantes
 * como cliques no WhatsApp
 */
export const GOOGLE_ADS = {
  conversionId: 'AW-17205890462/EtByCNG8jtsaEJ6btIxA'
} as const;

/**
 * Helper function para gerar URL do Google Maps
 * 
 * @param address - Endereço a ser pesquisado
 * @returns URL formatada para abrir no Google Maps
 */
export function getGoogleMapsSearchUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
